<div class="header-div">
  <span class="pay_rates">Pay rates other applicants submitted</span>
</div>

<div class="chart-wrapper">
  <canvas
    baseChart
    [data]="barChartData"
    [options]="barChartOptions"
    [type]="barChartType">
  </canvas>
</div>
